import { createContext, useContext } from "react"
import { isTelegramEnv } from "utils/tgWebApp"

export type Orientation = "portrait" | "landscape"

export type ViewportContextValue = {
  width: number
  height: number
  orientation: Orientation
  isMobile: boolean
  isTelegramEnv: boolean
}

const defaultValue: ViewportContextValue = {
  width: typeof window !== "undefined" ? window.innerWidth : 0,
  height: typeof window !== "undefined" ? window.innerHeight : 0,
  orientation:
    typeof window !== "undefined" && window.innerWidth < window.innerHeight
      ? "portrait"
      : "landscape",
  isMobile:
    typeof navigator !== "undefined"
      ? /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      : false,
  isTelegramEnv: typeof window !== "undefined" ? isTelegramEnv() : false
}

export const WebAppViewportContext =
  createContext<ViewportContextValue>(defaultValue)

export const useWebAppViewport = () => useContext(WebAppViewportContext)
